module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate",
    attrs: {
      "id": "donate"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Поддержать")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                    А мы вам за это инвайт, когда состоится релиз. "), _c('br'), _vm._v("\n                    Бета-тестовый вход, скидки и всякие плюшки когда запустимся.\n\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 donate-content animateblock btt speed-1"
  }, [_c('div', {
    staticClass: "col-md-6 box"
  }, [_c('img', {
    attrs: {
      "src": "landing/static/images/donate_img_1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 box"
  }, [_c('img', {
    attrs: {
      "src": "landing/static/images/donate_img_2.png",
      "alt": ""
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6712c4e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Donate.vue
// module id = 1233
// module chunks = 1